import { useLocation } from "react-router-dom";

const PV_CONFIG: Record<string, string> = {
  "/login": "login_pv",
  "/home": "home_pv",
  "/chat": "chat_pv",
  "/fileChat": "doc_chat_pv",
  "/fileUpload": "doc_upload_pv",
};

const useTrackCLK = (disabled?: boolean) => {
  const { pathname } = useLocation();

  const sendPV = (pathname: string) => {
    if (disabled) return;
    try {
      const key = PV_CONFIG[pathname];
      if (!!key) {
        sendCLK(key);
      }
    } catch (error) {
      console.log("sendPV error: ", error);
    }
  };

  const sendCLK = (
    action: string,
    label?: string,
    value?: number,
    nodeid?: string,
  ) => {
    if (disabled) return;
    try {
      // const category = window.location.pathname;
      // let category = PAGE_CATEGORY[pathname];
      // !category && (category = "default");

      // @ts-ignore
      if (window._czc) {
        // @ts-ignore
        window._czc.push([
          "_trackEvent",
          pathname,
          action,
          label,
          value,
          nodeid,
        ]);
      }
    } catch (error) {
      console.log("sendCLK error: ", error);
    }
  };

  return {
    sendCLK,
    sendPV,
  };
};

export default useTrackCLK;
